export enum EExploreItem {
  ORGANIZATION = 'organization',
  SITE = 'site',
  BUILDING = 'building',
  SUBBUILDING = 'subbuilding',
  FLOOR = 'floor',
  SPACE = 'space',
}

export enum ECookieName {
  /**
   * Stores the Azure Subscription JSON object
   */
  AZURE_SUBSCRIPTION = 'mapped_azure_subscription',
  /**
   * Marks a session as internal (Mapped team)
   */
  INTERNAL = 'mapped_internal',
  /**
   * Clouflare Session Cookie
   */
  CF_SESSION = 'CF_AppSession',
  /**
   * Cookie consent decision (accepted/declined)
   */
  COOKIE_CONSENT = 'cookie_consent',
}

export enum EStorageKey {
  /**
   * Stores the current auth token
   */
  AUTH_TOKEN = 'mapped:auth_token',

  /**
   * Stores the refresh token
   */
  REFRESH_TOKEN = 'mapped:refresh_token',

  /**
   * The SSO orchestrator's id_token, kept only as the logout hint
   */
  ID_TOKEN = 'mapped:id_token',

  /**
   * A sign-in in progress (`state`, nonce, PKCE verifier, where to go next),
   * per tab, between `/auth/login` and `/auth/callback`
   */
  LOGIN_STATE = 'mapped:login_state',

  LEFT_PANEL = 'mapped:left_panel',
  DATA_GRID_FILTER = 'mapped:data_grid_filter',
  LEFT_PANEL_WIDTH = 'mapped:left_panel_width',
  GRID_CONNECTORS_COLUMN_VISIBILITY = 'mapped:grid_connectors_column_visibility',
  GRID_THINGS_COLUMN_VISIBILITY = 'mapped:grid_things_column_visibility',
  GRID_POINTS_COLUMN_VISIBILITY = 'mapped:grid_points_column_visibility',
  GRID_WORK_ORDERS_COLUMN_VISIBILITY = 'mapped:grid_work_orders_column_visibility',

  /**
   * Whether the geo view's layer panel is expanded, and how wide it is.
   */
  GEO_PLAN_PANEL = 'mapped:geo_plan_panel',
  GEO_PLAN_PANEL_WIDTH = 'mapped:geo_plan_panel_width',

  /**
   * Whether the explore grid's entity detail rail is open, and how wide it is.
   * Open state is deliberately separate from the `?sel=` URL param: an open
   * rail with nothing selected is a valid state (it shows the empty state),
   * and a selection auto-opens a closed rail without persisting that.
   */
  EXPLORE_GRID_PANEL = 'mapped:explore_grid_panel',
  EXPLORE_GRID_PANEL_WIDTH = 'mapped:explore_grid_panel_width',

  /**
   * Whether the grid's header filter row is shown. Off at rest, and stored per
   * tab by suffixing the tab name, because the row is useful on Things and
   * mostly disabled inputs on paginated Points.
   */
  EXPLORE_GRID_HEADER_FILTERS = 'mapped:explore_grid_header_filters',

  /**
   * Whether Things / Points are folded into one summary line per type. Stored
   * per tab by suffixing the tab name, like the header filter row.
   */
  EXPLORE_GRID_GROUP_BY_TYPE = 'mapped:explore_grid_group_by_type',

  /**
   * How group-by-type orders its groups: `count` (largest first) or `name`
   * (A–Z by class name). Stored per tab, like the grouping itself.
   */
  EXPLORE_GRID_GROUP_ORDER = 'mapped:explore_grid_group_order',

  /**
   * The time range the detail panel's Readings chart shows (`1h` / `6h` /
   * `24h`). A preference, not a selection: it follows the reader from point to
   * point, which is the whole reason it is not in the URL.
   */
  EXPLORE_GRID_READINGS_RANGE = 'mapped:explore_grid_readings_range',
}

export enum EStepToken {
  IDLE = 'IDLE',
  NEW = 'NEW',
  GENERATED = 'GENERATED',
}

export interface INextAPIError {
  error?: string
  stack?: any
}
